import React from 'react';

const Footer = (props: any) => (
    <div className="container px-6 mx-auto mt-16">    
    Changelog: 
    <div className="bg-teal-400 rounded p-2 font-mono"> 
        <ul>
            <li>2022-09-19 :: Added 8 >>> <a className="font-semibold" href="logs/2022-09-19.png">View Changes</a></li>
            <li>2022-09-13 :: Added 10, Updated 5 >>> <a className="font-semibold" href="logs/2022-09-13.png">View Changes</a></li>            
        </ul>
    </div>
        <div className="flex flex-col items-center">
            <div className="py-6 text-center sm:w-2/3">
                <p className="text-sm text-gray-600"> <a href="https://www.twitter.com/thyng" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    David Vallejo (@thyng) </a> © {(new Date().getFullYear())} by Analytics Debugger S.L.U. </p>
                <p className="text-sm text-gray-600"><a href="https://github.com/tailwindcomponents" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Cheatsheet Template by Tailwind Components</a></p>
            </div>
        </div>
    </div>
    
    
);

export default Footer;
